import { BCMSRecord, BCMSStateManagerCRUD, useBCMSContext } from "@bcm-dev/bcms-vite";
import NonNachaFileImportPage, { getDefaultUI } from "components/pages/NonNachaFileImportPage";
import Classes from "model";

/**
 * @name CaptureFileImportCompanyDropdown
 * @returns {React.Component}
 * @description 
 * This capture is used in the following capture groups:
 * "ACH - ImportFile (Non-NACHA)" (abi22).
 */
export default function CaptureFileImportCompanyDropdown(props) {
    const context = useBCMSContext();
    BCMSRecord.globalControllerFor(Classes, context);

    const ui = BCMSStateManagerCRUD.init(getDefaultUI())
    .update([ "companySelect", "isActive" ], true)
    .submit();

    return <NonNachaFileImportPage ui={ ui } />;
}